import * as AgGrid from "ag-grid-community";
import * as gridUtils from "grid/utils";
import * as datasource from "grid/datasource";
import { DEFAULT_COL_DEF, ACTIONS_COL_DEF, TEXT_FILTER_COL_DEF } from "../../grid/columns";
import * as columns from "grid/columns";
import * as http from "utils/http";
import * as notifications from "utils/notifications";
import { BankAccountType } from "./create_banking_profile_controller";
import { GridController } from "grid/grid_controller";

interface BankingProfile {
  bank_account_number: string;
  bank_account_type: BankAccountType;
  bank_name: string;
  bank_routing_number: string;
  email: string;
}

interface ParamsValue {
  url: string;
}

export default class extends GridController<BankingProfile> {
  static values = Object.assign(super.values, {
    params: Object,
  });

  declare readonly paramsValue: ParamsValue;

  async handleDeleteBankingProfile(event: CustomEvent<{ url: string }>) {
    const response = await http.httpDelete(event.detail.url);
    const data = await response.json();
    if (response.ok) {
      notifications.success(data.success);
      this.purgeCacheAndRefreshTable();
    } else {
      notifications.alert(data.error);
    }
  }

  override buildGrid() {
    const { accountTypesJson, i18nJson, paginationPageSize } = this.gridTarget.dataset;

    const colDefs: AgGrid.ColDef[] = [
      { field: "bank_name", ...DEFAULT_COL_DEF, ...TEXT_FILTER_COL_DEF },
      {
        field: "bank_account_type",
        ...DEFAULT_COL_DEF,
        ...columns.buildEnumColDef(JSON.parse(accountTypesJson)),
        ...columns.buildEnumFilterColDef(JSON.parse(accountTypesJson)),
      },
      { field: "bank_account_number", ...DEFAULT_COL_DEF, ...TEXT_FILTER_COL_DEF },
      { field: "bank_routing_number", ...DEFAULT_COL_DEF, ...TEXT_FILTER_COL_DEF },
      { field: "email", ...DEFAULT_COL_DEF, ...TEXT_FILTER_COL_DEF },
      {
        ...ACTIONS_COL_DEF,
        minWidth: 70,
        maxWidth: 90,
      },
    ];
    const dataSource = new datasource.Datasource({ callbacks: {}, limit: paginationPageSize });

    const options: AgGrid.GridOptions<BankingProfile> = {
      ...gridUtils.DEFAULT_GRID_OPTIONS,
      cacheBlockSize: parseInt(paginationPageSize),
      columnDefs: gridUtils.buildColumnDefs(colDefs, { i18n: JSON.parse(i18nJson) }),
      datasource: dataSource,
    };
    const gridApi = AgGrid.createGrid(this.gridTarget, options);
    dataSource.gridApi = gridApi;

    return gridApi;
  }

  purgeCacheAndRefreshTable() {
    if (!this.gridApi) return;
    this.gridApi.purgeInfiniteCache();
    this.gridApi.refreshInfiniteCache();
  }
}
